import Select, { components } from 'react-select'
import st from './Selector.module.scss'
import { ReactComponent as PinIcon } from './pin.svg'
import {useLocation, useNavigate} from 'react-router-dom';
import {useAppContext} from 'Context';
import {useRegions} from 'helpers';
import {useEffect} from 'react';

const styles = {
    control: (bs, state) => ({
        ...bs,
        backgroundColor: '#E7F2FE',
    })
}

export const Selector =()=> {
    const { data, dataList, isLoading } = useRegions()
    const navigate = useNavigate()
    const location = useLocation()
    const { setRegion, region } = useAppContext()
    useEffect(()=> {
        if (location.pathname.includes('representative') && !!data) {
            const id = Number(location.pathname.replace(/[^0-9]/g, '')) || null
            const region = data?.data?.data?.find(item => item.id === id)
            region ? setRegion(region) : navigate('/')
        }
    }, [setRegion, location, data, navigate])

    const handleChange = (val) => {
        val !== 0 ? setRegion(val) : setRegion(null)
        if (location?.pathname?.includes('representative')) {
            navigate('/representative/'+val.id)
        }
    }

    const options = (!!data && !!dataList) ? [data?.data?.data[0], ...dataList?.data?.data?.filter(item => item.active)] : []

    return (
        <div className={st.selector}>
            <div className={st.label}>Ваш регион</div>
            <Select
                styles={styles}
                options={options}
                value={region || 0}
                placeholder="Поиск ..."
                isClearable
                noOptionsMessage={()=> 'Не найдено.'}
                isLoading={isLoading}
                getOptionLabel={(option)=>option.name}
                getOptionValue={(option)=>option.id}
                onChange={handleChange}
                isSearchable
                components={{
                    DropdownIndicator: (props)=> {
                        return (
                            <components.DropdownIndicator {...props}>
                                <PinIcon />
                            </components.DropdownIndicator>
                        )
                    }
                }}
            />
        </div>
    )
}
